<script setup lang="ts">
import { useDetectMobile } from '@/application/composables/detectMobile.ts';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { ElButton, ElDrawer, ElDialog } from 'element-plus';
import { computed } from 'vue';

interface Props {
  show: boolean;
  title: string;
  height: string
}

const props = defineProps<Props>();
defineEmits(['close', 'closed']);

const { isMobile } = useDetectMobile();

// `height` beschreibt die nutzbare Höhe des Drawers. Das Inset der
// Navigationsleiste kommt dazu, weil `pb-safe` es sonst von `height` abzieht
// und der Inhalt je nach Navigationsart unterschiedlich viel Platz hätte.
// Nach oben ist die Statusleiste die Grenze, unabhängig davon was `height` sagt.
const drawerSize = computed(() => {
  // einheitenlose Werte ergänzt Element Plus sonst selbst um `px`
  const height = /^\d+(\.\d+)?$/.test(props.height) ? `${props.height}px` : props.height;

  return `min(calc(${height} + var(--safe-bottom)), calc(100% - var(--safe-top)))`;
});

</script>

<template>
  <ElDrawer
    v-if="isMobile"
    :model-value="show"
    direction="btt"
    :show-close="false"
    class="rounded-t-2xl pb-safe"
    header-class="mb-0 pb-1"
    modal
    :title="title"
    :size="drawerSize"
    @close="show && $emit('close')"
    @closed="$emit('closed')"
  >
    <template #header>
      <div class="flex flex-row items-center justify-between">
        <span class="text-xl text-gray-900">{{ title }}</span>
        <ElButton text circle class="!text-gray-900" aria-label="Schließen" @click="$emit('close')">
          <FaIcon name="times" />
        </ElButton>
      </div>
    </template>
    <slot />
  </ElDrawer>

  <ElDialog
    v-else
    :model-value="show"
    :width="512"
    :show-close="false"
    :title="title"
    align-center
    @close="show && $emit('close')"
    @closed="$emit('closed')"
  >
    <template #header>
      <div class="flex flex-row items-center justify-between">
        <span class="text-xl text-gray-900">{{ title }}</span>
        <ElButton text circle class="!text-gray-900" aria-label="Schließen" @click="$emit('close')">
          <FaIcon name="times" />
        </ElButton>
      </div>
    </template>
    <slot />
  </ElDialog>
</template>
